module.exports = __webpack_public_path__ + "img/复合移动机器人.f92830a0.jpg";